// extracted by mini-css-extract-plugin
export default {"input":"Search_input__klILD","btn":"Search_btn__uMWgM"};